import { Box, styled, Typography } from "@mui/material"
import { FC } from "react"

interface CustomEditorFooterProps {
  textLength: number
  maxTextLength: number
  displayStyle?: "percentage" | "count"
  isAtLimit?: boolean
  characterCountId?: string
}

export const CustomEditorFooter: FC<CustomEditorFooterProps> = ({
  textLength,
  maxTextLength,
  displayStyle = "count",
  isAtLimit = false,
  characterCountId = "editor-character-count"
}) => {
  if (displayStyle === "percentage") {
    return isAtLimit ? (
      <StyledParagraph
        id={characterCountId}
        component="p"
        variant="body2"
        aria-live="polite"
        aria-atomic="true"
        sx={{ color: "orange.700", textAlign: "left", paddingTop: 2 }}
      >
        The answer length limit for this question has been reached.
      </StyledParagraph>
    ) : null
  }

  return (
    <EditorFooter>
      <StyledParagraph
        id={characterCountId}
        component="p"
        variant="subtitle2"
        aria-live="polite"
        aria-atomic="true"
      >{`# of Characters: ${textLength}/${maxTextLength}`}</StyledParagraph>
    </EditorFooter>
  )
}

const EditorFooter = styled(Box)(
  ({ theme }) => `
    border-radius: 0 0 ${theme.shape.borderRadius * 1.5}px ${
    theme.shape.borderRadius * 1.5
  }px;
    border: 1px solid ${theme.palette.grey[200]};
    border-top: none;
    padding: ${theme.spacing(1)} ${theme.spacing(3)};
`
)

const StyledParagraph = styled(Typography)<{ component: string }>(
  ({ theme }) => `
    margin: 0 !important;
    text-align: right;
  `
)
